import { useQuery, UseQueryResult } from "@tanstack/react-query";
import type { Budget } from "model";

import { api } from "~utils";

type useBudgetsType = (args: { showSuperadminBudgets: boolean }) => UseQueryResult<Budget[]>;

export const useBudgets: useBudgetsType = ({ showSuperadminBudgets }) => {
  return useQuery<Budget[]>({
    queryKey: ["budgets"],
    queryFn: async () => {
      const { data } = await api({ url: "/api/admin/budget" });
      return data || [];
    },
    select: (data: Budget[]) => {
      if (!showSuperadminBudgets) {
        return data.filter((budget: Budget) => !budget.hideFromAdmin) || [];
      }
      return data;
    },
  });
};
